// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"List__materialize-textarea___hCCOW","modal-2463794813":"List__modal-2463794813___Jw-1D","container":"List__container___2T9LC","listContainer":"List__listContainer___vSVXD","buynow":"List__buynow___3dmh7","buynowContainer":"List__buynowContainer___29L0X","priceValue":"List__priceValue___22nxu","coverText":"List__coverText___DhCGH","benefitContainer":"List__benefitContainer___3Yv6A"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PackagesList/List.scss
// module id = 1509
// module chunks = 0